import { render, staticRenderFns } from "./dataAny1.vue?vue&type=template&id=a46e5244&"
import script from "./dataAny1.vue?vue&type=script&lang=js&"
export * from "./dataAny1.vue?vue&type=script&lang=js&"
import style0 from "./dataAny1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports